
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotionTmResetProposal1 as ObiMotionTmResetProposal1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-motion-tm-reset-proposal-1.js';
 
 
 

 
 export const ObiMotionTmResetProposal1 = createComponent({
   react: React,
   tagName: 'obi-motion-tm-reset-proposal-1',
   elementClass: ObiMotionTmResetProposal1Element,
   events: {
     
   }
  });
 
 